import React from 'react';
import Icon from './Icon';

const fmtCount = (n) => (n >= 1000 ? `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k` : `${n}`);

/** Rating — a filled star, numeric value, optional review count. */
export default function Rating({ value, count, className = '' }) {
  if (value == null) return null;
  return (
    <span className={`rating${className ? ` ${className}` : ''}`} aria-label={`Rated ${value} out of 5`}>
      <Icon name="star" size={14} strokeWidth={0} className="rating__star" />
      <span className="rating__value">{Number(value).toFixed(1)}</span>
      {count != null && <span className="rating__count">({fmtCount(count)})</span>}
    </span>
  );
}
